import React, { useState, useEffect } from 'react';
import { useRoute } from '@react-navigation/native';
import {
  View,
  StyleSheet,
  useWindowDimensions,
  StatusBar,
  TouchableOpacity,
  Pressable,
} from 'react-native';
import { useAuth } from '../config/AuthContext';
import { Tab, Text, TabView } from '@rneui/themed';
import { BarChart, Grid, XAxis } from 'react-native-svg-charts';
import * as Svg from 'react-native-svg';
import config from '../config/config';

export function GraficoScreen() {
  const route = useRoute();
  const { deviceName } = route.params;
  const azureUrl = 'https://marrariprox.azurewebsites.net';
  const tableName = 'equipstates';
  const { maquinaId } = useAuth();
  const [index, setIndex] = React.useState(0);
  const [tipoMaq, setTipoMaq] = useState({});
  const [GrafDiasPcs, setGrafDiasPcs] = useState([]);
  const [GrafDiasM1, setGrafDiasM1] = useState([]);
  const [GrafDiasM2, setGrafDiasM2] = useState([]);
  const [GrafDiasM3, setGrafDiasM3] = useState([]);
  const [GrafDiasLabels, setGrafDiasLabels] = useState([]);
  const [GrafCompPcs, setGrafCompPcs] = useState([]);
  const [GrafCompM1, setGrafCompM1] = useState([]);
  const [GrafCompM2, setGrafCompM2] = useState([]);
  const [GrafCompM3, setGrafCompM3] = useState([]);
  const [GrafCompLabels, setGrafCompLabels] = useState([]);
  const [GrafLargPcs, setGrafLargPcs] = useState([]);
  const [GrafLargM1, setGrafLargM1] = useState([]);
  const [GrafLargM2, setGrafLargM2] = useState([]);
  const [GrafLargM3, setGrafLargM3] = useState([]);
  const [GrafLargLabels, setGrafLargLabels] = useState([]);
  const [GrafEspPcs, setGrafEspPcs] = useState([]);
  const [GrafEspM1, setGrafEspM1] = useState([]);
  const [GrafEspM2, setGrafEspM2] = useState([]);
  const [GrafEspM3, setGrafEspM3] = useState([]);
  const [GrafEspLabels, setGrafEspLabels] = useState([]);
  const [TotalPcs, setTotalPcs] = useState(0);
  const [TotalM1, setTotalM1] = useState(0);
  const [TotalM2, setTotalM2] = useState(0);
  const [TotalM3, setTotalM3] = useState(0);
  const [selectedChartComp, setSelectedChartComp] = useState('default');
  const [selectedChartLarg, setSelectedChartLarg] = useState('default');
  const [selectedChartEsp, setSelectedChartEsp] = useState('default');

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  async function fetchData() {
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });

      const data = await response.json();
      const parsedData = JSON.parse(data[0].dados);

      const tipoMaq = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.TipoMaq);
      setTipoMaq(tipoMaq);

      const GrafDiasPcs = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafDiasPcs);
      setGrafDiasPcs(GrafDiasPcs);

      const GrafDiasM1 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafDiasM1);
      setGrafDiasM1(GrafDiasM1);

      const GrafDiasM2 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafDiasM2);
      setGrafDiasM2(GrafDiasM2);

      const GrafDiasM3 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafDiasM3);
      setGrafDiasM3(GrafDiasM3);

      const GrafDiasLabels = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafDiasLabels);
      setGrafDiasLabels(GrafDiasLabels);

      const GrafCompPcs = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafCompPcs);
      setGrafCompPcs(GrafCompPcs);

      const GrafCompM1 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafCompM1);
      setGrafCompM1(GrafCompM1);

      const GrafCompM2 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafCompM2);
      setGrafCompM2(GrafCompM2);

      const GrafCompM3 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafCompM3);
      setGrafCompM3(GrafCompM3);

      const GrafCompLabels = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafCompLabels);
      setGrafCompLabels(GrafCompLabels);

      const GrafLargPcs = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafLargPcs);
      setGrafLargPcs(GrafLargPcs);

      const GrafLargM1 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafLargM1);
      setGrafLargM1(GrafLargM1);

      const GrafLargM2 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafLargM2);
      setGrafLargM2(GrafLargM2);

      const GrafLargM3 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafLargM3);
      setGrafLargM3(GrafLargM3);

      const GrafLargLabels = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafLargLabels);
      setGrafLargLabels(GrafLargLabels);

      const GrafEspPcs = parsedData
        .filter((item) => item.Nome == deviceName)
        .map((item) => item.GrafEspPcs);
      setGrafEspPcs(GrafEspPcs);

      const GrafEspM1 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafEspM1);
      setGrafEspM1(GrafEspM1);

      const GrafEspM2 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafEspM2);
      setGrafEspM2(GrafEspM2);

      const GrafEspM3 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafEspM3);
      setGrafEspM3(GrafEspM3);

      const GrafEspLabels = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.GrafEspLabels);
      setGrafEspLabels(GrafEspLabels);

      const TotalPcs = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.TotalPcs);
      setTotalPcs(TotalPcs);

      const TotalM1 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.TotalM1);
      setTotalM1(TotalM1);

      const TotalM2 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.TotalM2);
      setTotalM2(TotalM2);

      const TotalM3 = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.TotalM3);
      setTotalM3(TotalM3);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  const colorFillProducao = 'rgb(134, 65, 244)';
  const colorFillLargura = 'rgb(255, 127, 14)';
  const colorFillEspessura = 'rgb(255, 205, 86)';
  const colorFillComprimento = 'rgb(77, 182, 172)';

  //Producao Pecas
  const data =
    GrafDiasPcs.length > 0 && Array.isArray(GrafDiasPcs[0])
      ? GrafDiasPcs[0]
      : [];
  const labels = GrafDiasLabels.length > 0 ? GrafDiasLabels[0] : [];

  //Comprimento
  const dataGrafCompPcs =
    GrafCompPcs.length > 0 && Array.isArray(GrafCompPcs[0])
      ? GrafCompPcs[0]
      : [];
  const dataGrafCompM1 =
    GrafCompM1.length > 0 && Array.isArray(GrafCompM1[0])
      ? GrafCompM1[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafCompM2 =
    GrafCompM2.length > 0 && Array.isArray(GrafCompM2[0])
      ? GrafCompM2[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafCompM3 =
    GrafCompM3.length > 0 && Array.isArray(GrafCompM3[0])
      ? GrafCompM3[0].map((value) => Number(value.toFixed(2)))
      : [];
  const labelsCompPcs = GrafCompLabels.length > 0 ? GrafCompLabels[0] : [];

  //Largura
  const dataGrafLargPcs =
    GrafLargPcs.length > 0 && Array.isArray(GrafLargPcs[0])
      ? GrafLargPcs[0]
      : [];
  const dataGrafLargM1 =
    GrafLargM1.length > 0 && Array.isArray(GrafLargM1[0])
      ? GrafLargM1[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafLargM2 =
    GrafLargM2.length > 0 && Array.isArray(GrafLargM2[0])
      ? GrafLargM2[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafLargM3 =
    GrafLargM3.length > 0 && Array.isArray(GrafLargM3[0])
      ? GrafLargM3[0].map((value) => Number(value.toFixed(2)))
      : [];
  const labelsLargPcs = GrafLargLabels.length > 0 ? GrafLargLabels[0] : [];

  //Espessura
  const dataGrafEspPcs =
    GrafEspPcs.length > 0 && Array.isArray(GrafEspPcs[0]) ? GrafEspPcs[0] : [];
  const dataGrafEspM1 =
    GrafEspM1.length > 0 && Array.isArray(GrafEspM1[0])
      ? GrafEspM1[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafEspM2 =
    GrafEspM2.length > 0 && Array.isArray(GrafEspM2[0])
      ? GrafEspM2[0].map((value) => Number(value.toFixed(2)))
      : [];
  const dataGrafEspM3 =
    GrafEspM3.length > 0 && Array.isArray(GrafEspM3[0])
      ? GrafEspM3[0].map((value) => Number(value.toFixed(2)))
      : [];
  const labelsEspPcs = GrafEspLabels.length > 0 ? GrafEspLabels[0] : [];

  //Dados Totais
  const dataTotalPcs = TotalPcs.length > 0 ? TotalPcs[0] : [];
  const dataTotalM1 = TotalM1.length > 0 ? TotalM1[0] : [];
  const dataTotalM2 = TotalM2.length > 0 ? TotalM2[0] : [];
  const dataTotalM3 = TotalM3.length > 0 ? TotalM3[0] : [];

  const layout = useWindowDimensions();

  const Labels = ({ x, y, bandwidth, data }) =>
    data.map((value, index) => (
      <Svg.Text
        key={index}
        x={x(index) + bandwidth / 2 + 10}
        y={y(value) - 10}
        fontSize={12}
        fill="black"
        alignmentBaseline="middle"
        textAnchor="middle"
        transform={`rotate(-270, ${x(index) + bandwidth / 2}, ${
          y(value) - 10
        })`}
      >
        {value}
      </Svg.Text>
    ));

  if (tipoMaq[0] === 0 || tipoMaq[0] === 1) {
    return (
      <>
        <Tab
          value={index}
          onChange={(e) => setIndex(e)}
          height={35}
          accessibilityIgnoresInvertColors={'#CCCCCA'}
          indicatorStyle={{
            backgroundColor: '#F3F3F1',
          }}
        >
          <Tab.Item
            title="Produção/dia"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 13,
              height: 50,
            })}
          />
        </Tab>

        <TabView
          value={index}
          onChange={setIndex}
          animationType="spring"
          initialLayout={{ width: layout.width }}
        >
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {data.length > 0 ? (
              <View style={{ height: 555, padding: 20 }}>
                {/* Gráfico de Barras */}
                <BarChart
                  style={styles.barChart}
                  data={data}
                  svg={{ fill: colorFillProducao }}
                  contentInset={{ top: 20, bottom: 20 }}
                >
                  <Labels />
                  <Grid />
                </BarChart>

                {/* Eixo X com os dias */}
                <XAxis
                  style={styles.xaxisProd}
                  data={data}
                  formatLabel={(value, index) => labels[index] || ''}
                  contentInset={{ left: 10, right: 10 }}
                  svg={{
                    fontSize: 12,
                    fill: 'black',
                    rotation: 90,
                    translateY: 20,
                    originY: 5,
                  }}
                />
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>
        </TabView>
      </>
    );
  } else if (tipoMaq[0] === 2) {
    return (
      <>
        <Tab
          value={index}
          onChange={(e) => setIndex(e)}
          height={40}
          accessibilityIgnoresInvertColors={'#CCCCCA'}
          indicatorStyle={{
            backgroundColor: '#F3F3F1',
          }}
        >
          <Tab.Item
            title="Prod/Dia"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 12,
              height: 60,
            })}
          />
          <Tab.Item
            title="Comprimento"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 12,
              height: 40,
              width: 110,
            })}
          />
          <Tab.Item
            title="Largura"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 12,
              height: 40,
              width: 110,
            })}
          />
          <Tab.Item
            title="Espessura"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 12,
              height: 40,
              width: 110,
            })}
          />
        </Tab>

        <TabView value={index} onChange={setIndex} animationType="spring">
          {/* Producao/dia */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {data.length > 0 ? (
              <View style={{ height: 555, padding: 20 }}>
                <BarChart
                  style={styles.barChart}
                  data={data}
                  svg={{ fill: colorFillProducao }}
                  contentInset={{ top: 20, bottom: 20 }}
                >
                  <Labels />
                  <Grid />
                </BarChart>

                <XAxis
                  style={styles.xaxisProd}
                  data={data}
                  formatLabel={(value, index) => labels[index] || ''}
                  contentInset={{ left: 10, right: 10 }}
                  svg={{
                    fontSize: 12,
                    fill: 'black',
                    rotation: 90,
                    translateY: 20,
                    originY: 5,
                  }}
                />
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>

          {/* Comprimento */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {dataGrafCompPcs.length > 0 ? (
              <View style={{ height: 540, padding: 20 }}>
                {selectedChartComp === 'default' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(un)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompPcs}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 20, bottom: 20 }}
                      title="Comprimento Unidade"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompPcs}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM1' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM1}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Comprimento M1"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM1}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM2' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m²)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM2}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Comprimento M2"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM2}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM3' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m³)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM3}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 30, bottom: 20 }}
                      title="Comprimento M3"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM3}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {/* Botões */}
                <View style={styles.cardButtons}>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'default'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('default')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'default'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalPcs}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM1'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM1')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM1'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM1}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM2'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM2')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM2'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM2}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM3'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM3')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM3'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM3}
                    </Text>
                  </Pressable>
                </View>
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>

          {/* Largura */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {dataGrafLargPcs.length > 0 ? (
              <View style={{ height: 540, padding: 20 }}>
                {selectedChartLarg === 'default' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Largura(un)</Text>
                    </View>
                    <BarChart
                      style={{ flex: 1, marginBottom: -10 }}
                      data={dataGrafLargPcs}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 20, bottom: 20 }}
                      title="Largura Unidade"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargPcs}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM1' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Largura(m)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM1}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Largura M1"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM1}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM2' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Largura(m²)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM2}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Largura M2"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM2}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM3' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Largura(m³)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM3}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 30, bottom: 20 }}
                      title="Largura M3"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM3}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {/* Botões */}
                <View style={styles.cardButtons}>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'default'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('default')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'default'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalPcs}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM1'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM1')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM1'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM1}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM2'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM2')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM2'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM2}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM3'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM3')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM3'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM3}
                    </Text>
                  </Pressable>
                </View>
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>

          {/* Espessura */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {dataGrafEspPcs.length > 0 ? (
              <View style={{ height: 540, padding: 20 }}>
                {/* Gráfico de Barras */}
                {selectedChartEsp === 'default' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Espessura(un)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafEspPcs}
                      svg={{ fill: colorFillEspessura }}
                      contentInset={{ top: 20, bottom: 20 }}
                      title="Espessura Unidade"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisEsp}
                      data={dataGrafEspPcs}
                      formatLabel={(value, index) => labelsEspPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartEsp === 'grafEspM1' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Espessura(m)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafEspM1}
                      svg={{ fill: colorFillEspessura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Espessura M1"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisEsp}
                      data={dataGrafEspM1}
                      formatLabel={(value, index) => labelsEspPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartEsp === 'grafEspM2' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Espessura(m²)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafEspM2}
                      svg={{ fill: colorFillEspessura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Espessura M2"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisEsp}
                      data={dataGrafEspM2}
                      formatLabel={(value, index) => labelsEspPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartEsp === 'grafEspM3' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Espessura(m³)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafEspM3}
                      svg={{ fill: colorFillEspessura }}
                      contentInset={{ top: 30, bottom: 20 }}
                      title="Espessura M3"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>

                    <XAxis
                      style={styles.xaxisEsp}
                      data={dataGrafEspM3}
                      formatLabel={(value, index) => labelsEspPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {/* Botões */}
                <View style={styles.cardButtons}>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartEsp === 'default'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartEsp('default')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartEsp === 'default' ? '#969593' : '#FFF',
                        },
                      ]}
                    >
                      {TotalPcs}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartEsp === 'grafEspM1'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartEsp('grafEspM1')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartEsp === 'grafEspM1'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM1}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartEsp === 'grafEspM2'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartEsp('grafEspM2')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartEsp === 'grafEspM2'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM2}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartEsp === 'grafEspM3'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartEsp('grafEspM3')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartEsp === 'grafEspM3'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM3}
                    </Text>
                  </Pressable>
                </View>
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>
        </TabView>
      </>
    );
  } else if (tipoMaq[0] === 3 || tipoMaq[0] === 4) {
    return (
      <>
        <Tab
          value={index}
          onChange={(e) => setIndex(e)}
          height={40}
          accessibilityIgnoresInvertColors={'#CCCCCA'}
          indicatorStyle={{
            backgroundColor: '#F3F3F1',
          }}
        >
          <Tab.Item
            title="Prod/Dia"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 13,
              height: 40,
            })}
          />
          <Tab.Item
            title="Comprimento"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 13,
              height: 40,
              width: 115,
            })}
          />
          <Tab.Item
            title="Diâmetro"
            titleStyle={(active) => ({
              color: active ? '#0081Cf' : '#040404',
              fontSize: 13,
              height: 40,
              width: 110,
            })}
          />
        </Tab>

        {/* Producao */}
        <TabView value={index} onChange={setIndex} animationType="spring">
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {data.length > 0 ? (
              <View style={{ height: 555, padding: 20 }}>
                <BarChart
                  style={styles.barChart}
                  data={data}
                  svg={{ fill: colorFillProducao }}
                  contentInset={{ top: 20, bottom: 20 }}
                >
                  <Labels />
                  <Grid />
                </BarChart>

                <XAxis
                  style={styles.xaxisProd}
                  data={data}
                  formatLabel={(value, index) => labels[index] || ''}
                  contentInset={{ left: 10, right: 10 }}
                  svg={{
                    fontSize: 12,
                    fill: 'black',
                    rotation: 90,
                    translateY: 20,
                    originY: 5,
                  }}
                />
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>

          {/* Comprimento */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {dataGrafCompPcs.length > 0 ? (
              <View style={{ height: 540, padding: 20 }}>
                {selectedChartComp === 'default' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(un)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompPcs}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Comprimento Unidade"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompPcs}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM1' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM1}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Comprimento M1"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM1}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM2' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m²)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM2}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Comprimento M2"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM1}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartComp === 'grafCompM3' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Comprimento(m³)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafCompM3}
                      svg={{ fill: colorFillComprimento }}
                      contentInset={{ top: 30, bottom: 20 }}
                      title="Comprimento M3"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxisComp}
                      data={dataGrafCompM3}
                      formatLabel={(value, index) => labelsCompPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}
                <View style={styles.cardButtons}>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'default'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('default')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'default'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalPcs}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM1'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM1')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM1'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM1}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM2'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM2')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM2'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM2}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartComp === 'grafCompM3'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartComp('grafCompM3')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartComp === 'grafCompM3'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM3}
                    </Text>
                  </Pressable>
                </View>
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>

          {/* Diâmetro */}
          <TabView.Item style={{ backgroundColor: '#CCCCCA', width: '100%' }}>
            {dataGrafCompPcs.length > 0 ? (
              <View style={{ height: 540, padding: 20 }}>
                {selectedChartLarg === 'default' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Diâmetro(un)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargPcs}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Diâmetro Unidade"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargPcs}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM1' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Diâmetro(m)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM1}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Diâmetro M1"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM1}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM2' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Diâmetro(m²)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM2}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 35, bottom: 20 }}
                      title="Diâmetro M2"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM2}
                      contentInset={{ left: 10, right: 10 }}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}

                {selectedChartLarg === 'grafLargM3' && (
                  <>
                    <View style={[styles.cardContainer, {}]}>
                      <Text style={styles.textCard}>Diâmetro(m³)</Text>
                    </View>
                    <BarChart
                      style={styles.barChart}
                      data={dataGrafLargM3}
                      svg={{ fill: colorFillLargura }}
                      contentInset={{ top: 30, bottom: 20 }}
                      title="Diâmetro M3"
                    >
                      <Labels />
                      <Grid />
                    </BarChart>
                    <XAxis
                      style={styles.xaxis}
                      data={dataGrafLargM3}
                      formatLabel={(value, index) => labelsLargPcs[index] || ''}
                      contentInset={{ left: 10, right: 10 }}
                      svg={{
                        fontSize: 12,
                        fill: 'black',
                        rotation: 90,
                        translateY: 20,
                        originY: 5,
                      }}
                    />
                  </>
                )}
                <View style={styles.cardButtons}>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'default'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('default')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'default'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalPcs}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM1'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM1')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM1'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM1}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM2'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM2')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM2'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM2}
                    </Text>
                  </Pressable>
                  <Pressable
                    style={({ pressed }) => [
                      styles.button,
                      {
                        backgroundColor:
                          selectedChartLarg === 'grafLargM3'
                            ? '#c4c3c0'
                            : pressed
                            ? '#969593'
                            : '#969593',
                      },
                    ]}
                    onPress={() => setSelectedChartLarg('grafLargM3')}
                  >
                    <Text
                      style={[
                        styles.buttonTitle,
                        {
                          color:
                            selectedChartLarg === 'grafLargM3'
                              ? '#969593'
                              : '#FFF',
                        },
                      ]}
                    >
                      {TotalM3}
                    </Text>
                  </Pressable>
                </View>
              </View>
            ) : (
              <Text>Carregando dados...</Text>
            )}
          </TabView.Item>
        </TabView>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chart: {
    marginVertical: 8,
    borderRadius: 16,
  },
  button: {
    backgroundColor: '#969593',
    width: 150,
    height: 35,
    borderRadius: 10,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  buttonTitle: {
    color: '#FBFAF8',
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  cardContainer: {
    backgroundColor: '#F3F3F1',
    borderRadius: 5,
    width: 200,
    marginBottom: 10,
  },
  textCard: {
    fontSize: 18,
    alignSelf: 'center',
    color: '#0081CF',
    paddingBottom: 2,
  },
  barChart: {
    marginTop: -15,
    height: 400,
  },
  //Para graficos de comprimento
  xaxisComp: {
    height: 60,
  },
  //APenas para os graficos de produção
  xaxisProd: {
    marginTop: 10,
    height: 80,
  },
  //Para graficos de expessura
  xaxisEsp: {
    height: 60,
  },
  //Para graficos de largura e diametro
  xaxis: {
    height: 60,
  },
  cardButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: -50,
  },
});
